import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { Subject, Subscription, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DtcSearchService } from 'src/app/services/feature/dtcSearch/dtc-search.service';
import { LanguageService } from '@spartacus/core';
@Component({
  selector: 'app-dtc-troubleshoot',
  templateUrl: './dtc-troubleshoot.component.html',
  styleUrls: ['./dtc-troubleshoot.component.scss'], // <-- note: styleUrls (plural)
  standalone: false,
})
export class DtcTroubleshootComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  private dtcService = inject(DtcSearchService);
  private cdr = inject(ChangeDetectorRef);
  private router = inject(Router);
  private platformId = inject(PLATFORM_ID);
  protected languageService = inject(LanguageService);
  dtcTroubleData: any[] = [];
  subscription = new Subscription();
  /** Same key used by the sender */
  private readonly SESSION_KEY = 'dtc:last';
  private dtcPayload: any;
  ngOnInit(): void {
    this.loadDtcDetails();
    this.subscription.add(
      this.languageService.getActive().pipe(
        debounceTime(300)
      ).subscribe(() => {
        this.loadDtcDetails();
      })
    );

  }
  loadDtcDetails() {
    let payload = this.dtcPayload;

    if (!payload) {
      const nav = this.router.currentNavigation();
      const routerState = nav?.extras?.state as { dtcData?: any } | undefined;
      payload = routerState?.dtcData;

      if (!payload && isPlatformBrowser(this.platformId)) {
        payload = this.consumeFromSession();
      }

      if (!payload) {
        this.router.navigate(['DTCSearch']);
        return;
      }

      this.dtcPayload = payload;
    }

    of(payload)
      .pipe(
        switchMap((dto) => this.dtcService.getDTCLookUpDetails(dto)),
        map((x: any) => x?.kbDtcList ?? []),
        tap((list) => (this.dtcTroubleData = list)),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.cdr.detectChanges());
  }
  /** Read once from session, clear, and honor TTL */
  private consumeFromSession(): any | null {
    try {
      const raw = sessionStorage.getItem(this.SESSION_KEY);
      if (!raw) return null;

      const record = JSON.parse(raw) as { payload: any; exp: number };
      // Expired or malformed → cleanup and ignore
      if (!record?.exp || Date.now() > record.exp) {
        sessionStorage.removeItem(this.SESSION_KEY);
        return null;
      }

      // Clear-on-consume so future clicks always write a fresh value
      sessionStorage.removeItem(this.SESSION_KEY);
      return record.payload;
    } catch {
      sessionStorage.removeItem(this.SESSION_KEY);
      return null;
    }
  }

  // goBack(): void {
  //   this.router.navigate(['DTCSearch'], {
  //     state: {
  //       restoreSearch: true
  //     }
  //   });
  // }
  goBack(): void {
    this.dtcService.setRestoreSearch(true);
    window.history.back();
  }

  ngOnDestroy(): void {
    /* this.subscription.unsubscribe(); */
    this.destroy$.next();
    this.destroy$.complete();
  }

}

